<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-2 customHeading">
          <h3>{{moduleName}}</h3>
        </div>
        <div class = "col-md-4 green-text">
          <b>Remaining Issued Stock in KGs: &nbsp;&nbsp;{{issuedStock != null ? issuedStock.totalWeightInKgs:0}}</b>
        </div>
        <!--==========Class dropdown============-->
        <div class="col-md-3">
            
            <b-form-datepicker id="datepicker-1" v-model= "ProdDate" placeholder="Choose a date" local="en" @input="getProductions()" required></b-form-datepicker>
        
        </div>

        <!---SEARCH BOX-->
        <div class="col-md-2">
          <div class="searchbox input-group" role="group">
            <input class="form-control search-box my-search-box" type="text" placeholder="Flour Type" aria-label="search" v-model="filteredText">
          
            <button class="search-button btn btn-primary filter"  @click="getProductions()"><i class="fa fa-search search-icon"></i></button>
          </div>    
        </div>

        <div class="col-md-1 Add-button" style="text-align:center">
          <a href="javascript:void(0)">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn" v-b-modal.AddProductionModal>Add </div>
            </div>
          </a>
        </div> 

      </div>
      <div class="row">
        <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col">
            <table class="table table-striped table-borderless cutom-table table-striped table-sm" style="font-size: 85%;">
              <thead>
                <tr>
              
                  <th role="columnheader">Time</th>
                  <th role="columnheader">Flour Type</th>
                  <th role="columnheader">Weight</th>
                    <th role="columnheader">Quantity</th>
                  <th role="columnheader" >Actions</th>
                </tr>
              </thead>
              <tbody>
                <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
                <tr v-if= "productions==null" >
                  <td class = "center-td" colspan="5">No Data</td>
                </tr>
                
                <tr v-else v-for="record in productions" :key=record.id>
                  <td  role="cell">{{record.time.timeSlot}}</td>
                  
                  <td  role="cell">{{record.flourTypeWeightLink.flourType.name}} </td>
                  <td  role="cell">{{record.flourTypeWeightLink.flourWeight.weight}} </td>
                  <td  role="cell">{{record.noOfSacksProduced}} </td>
                  <td>
                  <span @click= "passRecordToEdit(record)">
                      <i role="button" style="color:green" class="far fa-edit"></i>&nbsp;|&nbsp;
                    </span>
                    <span @click= "passRecordToDelete(record.id)">
                      <i role="button" style="color:green" class="far fa-trash-alt"></i>
                    </span>
                
                  </td>
                </tr>
                <tr>
                  <td colspan ="3"></td>
                  <td><b>Total Sacks Produced: {{totalSacksProduced != null ? totalSacksProduced:0}}</b></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

   
    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getProductions()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>

    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
    <AddProductionModal/>
    <EditProductionModal :prodToEdit= "recordToEdit" v-if="recordToEdit != null"/>
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "recordToDelete"/>
   
   
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import AddProductionModal from './modals/AddProductionModal'
import DeleteModal from '../../modals/DeleteModal'
import EditProductionModal from './modals/EditProductionModal'

export default {
    name: 'Production',
    data(){
        return{
          moduleName:'Production',
     
          issuedStock:null,
          totalSacksProduced:null,
          isLoading:false,
          recordToEdit :  null,
          recordToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,
          ProdDate:new Date(),

             
          productions:null,
        
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25     
		}
  },
 
methods:{


    getPage(page)
  {
    this.page = page;
    this.getProductions();
  },

   passRecordToEdit(comp)
  {
    this.recordToEdit = comp;
    setTimeout(
      () => {
    this.$bvModal.show('EditProductionModal');
  },100)
  },
  passRecordToDelete(id)
  {
    this.recordToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "production/Delete/";
    this.deleteModalHeading = "Delete"
    this.$bvModal.show('DeleteModal')

  },
 
    getProductions(){
       this.isLoading = true;
      axios.post('/Production/getall',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText,"ProductionDate":this.ProdDate})
    .then(res=>{
      this. isLoading = false;

      if(res.data.status == 1)
      {
        console.log(res.data)
        this.productions=res.data.data.records;
        this.issuedStock = res.data.data.issuedStock;
        this.totalSacksProduced = res.data.data.totalSacksProduced
        this.rows = res.data.totalRecords;
      }
      else if(res.data.status== -1)
      {
          this.$bvModal.msgBoxOk(res.data.msg, {
          title: 'Error!',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          headerClass: 'p-10 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
      }
      else {
        this.productions = null;
        this.issuedStock = res.data.data.issuedStock;
      }
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getProductions();
  }
  },
	created(){
    this.getProductions();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    AddProductionModal,
    DeleteModal,
    EditProductionModal
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>